/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

const childRoutes: Array<{
    path: string;
    componentName: string;
    title: string;
}> = [];

// Enter a Lottery
childRoutes[childRoutes.length] = {
    path: '/lottery/available',
    componentName: 'AvailableLotteriesPage',
    title: 'Enter a Lottery',
};

// How does the lottery work?
childRoutes[childRoutes.length] = {
    path: '/lottery/how-they-work',
    componentName: 'HowLotteriesWorkPage',
    title: 'How does the lottery work?',
};

export default childRoutes;
